import React, { Fragment } from "react";
import { Button, Form, FormGroup, Label, Input,Col,Row } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { faS } from "@fortawesome/free-solid-svg-icons";
import { TimePicker } from "react-time-picker";
import "../../style/calendarclass.css";
import moment from "moment";
import Multiselect from 'multiselect-react-dropdown';
import "../../style/numbertextstyle.css";
const FormEditFields = (props) => {
  const { inputFields, formValidation,intimeval,outtimeval,halfdayworkval,fulldayworkval,handelonRemove } = props;
  let options=[];
  let selectedoptions=[];
  let selectedoptionsList=[];
  let currdate=new Date();
  let optionselectdep=[];
  let ampm="";
  //amPmAriaLabel
let intimRaw = props.formData?.val?.inTime || intimeval;
let outtimRaw = props.formData?.val?.outTime || outtimeval;

// Handle both "HH:mm:ss" and fallback to "HH:mm" or "hhmma"
let intim = moment(intimRaw, ["HH:mm:ss", "HH:mm", "hhmma"]).isValid()
  ? moment(intimRaw, ["HH:mm:ss", "HH:mm", "hhmma"]).format("HH:mm")
  : "00:00";

let outtim = moment(outtimRaw, ["HH:mm:ss", "HH:mm", "hhmma"]).isValid()
  ? moment(outtimRaw, ["HH:mm:ss", "HH:mm", "hhmma"]).format("HH:mm")
  : "00:00";
if(intimeval>12)
{
  ampm = "AM";
}
else
{
  ampm = "PM";
}
   inputFields.map(function (desig) {
   if(desig.type=="multipleselect" && desig.option.length >0)
    {
     
      if(props.selectedDesigList.length>0)
      {
        selectedoptionsList=props.selectedDesigList;
      }
      else
      {
        selectedoptionsList.splice(0, selectedoptionsList.length);
      }

     desig.option.map((el,i) =>{
      options.push({value: el.designationId, label: el.designationName }); 
      // props.handlesetAttribute(props.formData.val.designation);
      props.formData.val.designation.split(',').map(function (desId, index) {
        if(desId==el.designationId)
        {
          selectedoptions.push({value: el.designationId, label: el.designationName });
        }
    });
     
     })
     
    }
    if(desig.type=="selectdep" && desig.option.length >0)
    {
      // optionsprop.push({value:0,label:"Select..."})
      desig.option.map((el,i) =>{
        optionselectdep.push({
          value:el.officeLocationId,label:el.address})
    })
    }
  })
  const onRemove=(selectedList, removedItem) => {
    handelonRemove(selectedList,removedItem);
  }
  return (
    <Form onSubmit={props.handleSubmit}>
    
      {inputFields !== undefined
        ? inputFields.map((val, i) => {
            return (
              <FormGroup key={i} >
                
                <Label>{val.label}</Label>
                {val.type === "text" ? (
                 
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnChange(e.target.value);
                      props.handleOnchangeToSelectedData(
                        e.target.value,
                        val.name
                      );
                    }}
                    value={props.formData ? props.formData.val[val.name] : null}
                  />
                ) : null}
                {val.type === "text1" ? (
                 
                 <Input
                   type={val.type}
                   placeholder={val.placeholder}
                   onChange={(e) => {
                     val.handleOnChange(e.target.value);
                     props.handleOnchangeToSelectedData(
                       e.target.value,
                       val.name
                     );
                   }}
                   value={props.formData ? props.formData.val[val.name] : null}
                 />
               ) : null}
               {val.type === "textdes" ? (
                 
                 <Input
                   type={val.type}
                   placeholder={val.placeholder}
                   onChange={(e) => {
                     val.handleOnChange(e.target.value);
                     props.handleOnchangeToSelectedData(
                       e.target.value,
                       val.name
                     );
                   }}
                   value={props.formData ? props.formData.val[val.name] : null}
                 />
               ) : null}
               {val.type === "textname" ? (
                 
                 <Input
                   type="text"
                   placeholder={val.placeholder}
                   onChange={(e) => {
                     val.handleOnChange(e.target.value);
                     props.handleOnchangeToSelectedData(
                       e.target.value,
                       val.name
                     );
                   }}
                   value={props.formData ? props.formData.val[val.name] : null}
                 />
               ) : null}
                 {val.type === "number" ? (
                
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnNumberChange(e.target.value);
                      props.handleOnchangeToSelectedData(
                        e.target.value,
                        val.name
                      );
                    }}
                    value={props.formData ? props.formData.val[val.name] : null}
                  /> 
                ) : null}
                {val.type === "radio" ?(<div>
             
                  <Input type={val.type} checked={val.typename === props.formData.val[val.name] ?true :false} value={val.typename}  onChange={(e) => {
                      val.handleOnradioChange(e.target.value);
                      props.handleOnchangeToSelectedData(
                        e.target.value,
                        val.name
                      );
                    }}   name={val.name} /> {val.typename}
                
              </div> ) : null}
                {val.type === "file" ? (
                  
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnChange(e.target.files[0]);
                      props.handleOnchangeToSelectedData(
                        e.target.files[0],
                        val.name
                      );
                    }}
                    // value={props.formData ? props.formData.val[val.name] : null}
                  />
                ) : null}
                {val.type === "select" ? (

                    
                    <Input
                      type={val.type}
                      placeholder={val.placeholder}
                      onChange={(e) => {
                        val.handleOnChange(e.target.value);
                        props.handleOnchangeToSelectedData(
                          e.target.value,
                          val.name
                        );
                      }}
                    >
                      {val.option.map((el, i) => (
                        <option
                          key={i}
                          value={el[val.displayData["id"]]}
                          selected={
                            parseInt(el[val.displayData["id"]]) ===
                            (
                             (parseInt(props.formData.val.officeLocationId))
                            ||parseInt(props.formData.val.departmentId)
                            ||parseInt(props.formData.val.skillCategoryId)
                            ||parseInt(props.formData.val.technologyId)
                            ||parseInt(props.formData.val.designation)
                            ||parseInt(props.formData.val.certificationId)
                            ||parseInt(props.formData.val.locationId)
                            ||parseInt(props.formData.val.requestTypeId)
                            ||parseInt(props.formData.val.calendarYearTypeId)
                            ||parseInt(props.formData.val.skillId)
                            )
                              ? true
                              : false
                          }
                        >
                          {el[val.displayData["selectedData"]]}
                        </option>
                      ))}
                    </Input>
                 
                ) : null}

                { val.type === "selectdep" ? (
                 
                 <Fragment>

<Select
className="basic-single"
classNamePrefix="select"
defaultValue={optionselectdep[0]}
onChange={(e) => {
  val.handleOnChange(e.value,e);
}} 
isSearchable={true}
value={props.formvaltype}
name="color"
options={optionselectdep}
/>
</Fragment>):null          }
{val.type === "time"? (
             
                <TimePicker onChange={(e) => {
                  val.handleOnChange(e);
                }} placeholder={val.placeholder}
                
                value={moment(props.formData.val.fullDayWorkingHours, "hhmm").format("HH:mm") } format="HH:mm" closeClock={false} disableClock={true} 
                selected={moment(fulldayworkval, "hhmm").format("HH:mm")  } locale="sv-sv"/>
            
              ) : null}
              {val.type === "timehalf"? (
                       
              
              <TimePicker onChange={(e) => {
                val.handleOnChange(e);
              }} placeholder={val.placeholder}
              
              value={moment(props.formData.val.halfDayWorkingHours, "hhmm").format("HH:mm")} format="HH:mm" closeClock={false} disableClock={true} 
              selected={moment(props.formData.val !== null ? props.formData.val: halfdayworkval, "hhmm").format("HH:mm")  } locale="sv-sv"/>
          
         ) : null}
              {val.type === "timeAmPm"? (
                             
               
                <TimePicker onChange={(e) => {
                  val.handleOnChange(e);
                }} placeholder={val.placeholder}
                value={intim} format="hh:mm a" closeClock={false} disableClock={true} locale="en-US"
                selected={intim } />
             
              ) : null}
              {val.type === "timeAmPmout"? (
              
               
              <TimePicker onChange={(e) => {
                val.handleOnChange(e);
              }} placeholder={val.placeholder}
              value={outtim} format="hh:mm a" closeClock={false} disableClock={true}
              selected={outtim} locale="en-US"/>
           
            ) : null}
{val.type === "multipleselect" ? (
              
        //              <Select style={{color:"black"}}
        //  isMulti defaultValue={ selectedoptionsList.length > 0 ?selectedoptionsList : selectedoptions} value={selectedoptionsList.length > 0 ?selectedoptionsList : selectedoptions}  options={options} 
        //  onChange={(e) => {
        //    val.handleOnChange(e[e.length-1].value,selectedoptions,e[e.length-1]);
        //  }}>
            
          
        //    </Select>
        <Multiselect
        options={options} // Options to display in the dropdown
        selectedValues={selectedoptionsList} // Preselected value to persist in dropdown
        onSelect={(e) => {
          val.handleOnChange(e[e.length-1].value,selectedoptions,e[e.length-1]);
        }} // Function will trigger on select event
        onRemove={onRemove} // Function will trigger on remove event
        displayValue="label" // Property name to display in the dropdown options
        />
                ) : null}

{val.type === "DateFrom"? (
             
               <DatePicker
                selected={props.formval ? new Date(props.formData.val.monthDurationFrom) : null}
                // value={props.formval}
                onChange={(e) => {
                  val.handleOnChange(e);
                  props.handleOnchangeToSelectedData(
                    e,
                    val.name
                  );
                }}
              
           />
              ) : null}
             {val.type === "DateTo"? (
              
              <DatePicker
                selected={props.toval ? new Date(props.formData.val.monthDurationTo) : null}
 
                onChange={(e) => {
                  val.handleOnChange(e);
                  props.handleOnchangeToSelectedData(
                    e,
                    val.name
                  );
                }}

           />
              ) : null}
             {val.type === "checkbox"? (
                 
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    defaultChecked={(props.checked || props.formData.val[val.name]) == true ? true :false}
                    onChange={(e) => {
                      val.handleCheckbox(e.target.value);
                    }}   
                    value={props.checked ? props.formData.val[val.name] : null}  
                  />
               ) : null}
{val.type === "checkboxCal"? (
                   
                   <Input
                   className="calendaryearcheckboxedit"
                 
                  // style="margin-left: -126px !important;margin-top: 13px;"
                     type="checkbox"
                     placeholder={val.placeholder}
                     onChange={(e) => {
                       val.handleOnChange(e.target.value);
                     }} 
                     defaultChecked={props.checked}  
                     value={props.checked}  
                   />
                ) : null}

              {/* { val.type === "multipleselect" && val.option.length >0 ? (
                 
                  <Fragment>
 
           <Select style={{color:"black"}}
         isMulti  options={options}  onChange={(e) => {
           val.handleOnChange(e[e.length-1].value);
         }}>
            
          
           </Select>
                  </Fragment>
                ) : null}*/}
                {Object.keys(formValidation)?.length !== 0 &&
                  !formValidation?.[val.name]?.isValid && (
                    <span className=" " style={{ color: "red" }}>
                      {formValidation?.[val.name]?.errorMessage}
                    </span>
                  )}
              </FormGroup>
            );
          })
        : null}
      
      
      <Button
        color=""
        className="btn-admin-settings"
        onClick={props.handleSubmit}
      >
        {props.button}
      </Button>{" "}
      &nbsp;
      <Button color="" className="btn-cancel" onClick={props.toggle}>
        Cancel
      </Button>
    </Form>
  );
};

export default FormEditFields;
